var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.607422C3.32016 0.607422 0.333496 3.59409 0.333496 7.27409C0.333496 10.9541 3.32016 13.9408 7.00016 13.9408C10.6802 13.9408 13.6668 10.9541 13.6668 7.27409C13.6668 3.59409 10.6802 0.607422 7.00016 0.607422ZM10.3335 7.94076H7.66683V10.6074H6.3335V7.94076H3.66683V6.60742H6.3335V3.94076H7.66683V6.60742H10.3335V7.94076Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.0156b9d1.svg";
export { ForwardRef as ReactComponent };